import { setScrollingProgrammatically } from './scrollToTarget.js';

export function scrollToAnchor(elems) {
  if (!elems || !elems.length) return;

  const DURATION = 600;
  const SCROLL_OFFSET = 32;
  const ACTIVE_CLASS = 'anchor-nav__link--is-active';

  const links = Array.from(elems);
  const sections = links
    .map((link) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return null;

      const id = href.slice(1);
      return document.querySelector(`#${CSS.escape(id)}`);
    })
    .filter(Boolean);

  links.forEach((link) => {
    link.addEventListener('click', handleAnchorClick);
  });

  function handleAnchorClick(event) {
    const link = event.currentTarget;
    const href = link.getAttribute('href');
    if (!href || href === '#') return;

    const id = href.slice(1);
    const target = document.querySelector(`#${CSS.escape(id)}`);
    if (!target) return;

    event.preventDefault();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      target.scrollIntoView();
      return;
    }

    const start = window.pageYOffset;
    const end =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      SCROLL_OFFSET;
    const distance = end - start;
    const startTime = performance.now();

    setScrollingProgrammatically(true);

    requestAnimationFrame(step);

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / DURATION, 1);

      window.scrollTo(0, start + distance * easeInOutCubic(progress));

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        setScrollingProgrammatically(false);
      }
    }
  }

  window.addEventListener('scroll', updateActiveLink, { passive: true });
  updateActiveLink();

  function updateActiveLink() {
    const offset = getScrollOffset();
    const triggerLine = window.pageYOffset + window.innerHeight * 0.5 + offset;

    let activeIndex = -1;

    sections.forEach((section, index) => {
      const top = section.offsetTop;
      const bottom = top + section.offsetHeight;

      if (triggerLine >= top && triggerLine < bottom) {
        activeIndex = index;
      }
    });

    setActiveByIndex(activeIndex);
  }

  function setActiveByIndex(index) {
    links.forEach((link) => {
      link.classList.remove(ACTIVE_CLASS);
      link.removeAttribute('aria-current');
    });

    if (index === -1) return;

    links[index].classList.add(ACTIVE_CLASS);
    links[index].setAttribute('aria-current', 'true');
  }

  function getScrollOffset() {
    const body = document.body;

    let offset =
      parseInt(getComputedStyle(document.documentElement).getPropertyValue('--scroll-offset'), 10) || 0;

    // if (body.classList.contains('nav--hidden')) {
    //   offset += 20;
    // } else {
    //   offset += 140;
    // }

    if (body.classList.contains('nav--hidden')) {
      offset += 20;
    }

    return offset;
  }

  function easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
}
